// Обновленный App.js с добавленными маршрутами для ценников
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// Контексты
import { AuthProvider } from './contexts/AuthContext';

// Компоненты
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';

// Страницы
import LoginPage from './pages/Login';
import DashboardPage from './pages/Dashboard';
import UsersPage from './pages/Users';
import ProductsPage from './pages/Products';
import ProductDetailsPage from './pages/ProductDetailsPage';
import ProductFormPage from './pages/ProductFormPage';
import PriceTagsPage from './pages/PriceTags';
import PriceTagDetailPage from './pages/PriceTagDetailPage';
import PriceTagFormPage from './pages/PriceTagFormPage';
import StoresPage from './pages/Stores';
import CategoriesPage from './pages/Categories';
import ReportsPage from './pages/Reports';
import OneCReport from './pages/OneCReport';
import UnauthorizedPage from './pages/Unauthorized';
import ManufacturersPage from './pages/Manufacturers';
import SettingsPage from './pages/Settings';
import ErrorLogsPage from './pages/ErrorLogs';

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/unauthorized" element={<Layout><UnauthorizedPage /></Layout>} />

          <Route path="/" element={
            <ProtectedRoute>
              <Layout>
                <DashboardPage />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/users" element={
            <ProtectedRoute requiredRole="admin">
              <Layout>
                <UsersPage />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/manufacturers" element={
            <ProtectedRoute requiredRole="manager,admin">
              <Layout>
                <ManufacturersPage />
              </Layout>
            </ProtectedRoute>
          } />

          {/* Маршруты для товаров */}
          <Route path="/products" element={
            <ProtectedRoute>
              <Layout>
                <ProductsPage />
              </Layout>
            </ProtectedRoute>
          } />

          {/* Маршрут для создания нового товара */}
          <Route path="/products/new" element={
            <ProtectedRoute requiredRole="manager,admin">
              <Layout>
                <ProductFormPage />
              </Layout>
            </ProtectedRoute>
          } />

          {/* Маршрут для просмотра деталей товара */}
          <Route path="/products/:id" element={
            <ProtectedRoute>
              <Layout>
                <ProductDetailsPage />
              </Layout>
            </ProtectedRoute>
          } />

          {/* Маршрут для редактирования товара */}
          <Route path="/products/:id/edit" element={
            <ProtectedRoute requiredRole="manager,admin">
              <Layout>
                <ProductFormPage />
              </Layout>
            </ProtectedRoute>
          } />

          {/* Маршруты для ценников */}
          <Route path="/price-tags" element={
            <ProtectedRoute>
              <Layout>
                <PriceTagsPage />
              </Layout>
            </ProtectedRoute>
          } />

          {/* Маршрут для создания нового ценника */}
          <Route path="/price-tags/new" element={
            <ProtectedRoute>
              <Layout>
                <PriceTagFormPage />
              </Layout>
            </ProtectedRoute>
          } />

          {/* Маршрут для просмотра деталей ценника */}
          <Route path="/price-tags/:id" element={
            <ProtectedRoute>
              <Layout>
                <PriceTagDetailPage />
              </Layout>
            </ProtectedRoute>
          } />

          {/* Маршрут для редактирования ценника */}
          <Route path="/price-tags/:id/edit" element={
            <ProtectedRoute>
              <Layout>
                <PriceTagFormPage />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/stores" element={
            <ProtectedRoute>
              <Layout>
                <StoresPage />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/categories" element={
            <ProtectedRoute>
              <Layout>
                <CategoriesPage />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/reports" element={
            <ProtectedRoute>
              <Layout>
                <ReportsPage />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/reports/1c" element={
            <ProtectedRoute requiredRole="manager,admin">
              <Layout>
                <OneCReport />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/settings" element={
            <ProtectedRoute requiredRole="admin">
              <Layout>
                <SettingsPage />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/error-logs" element={
            <ProtectedRoute requiredRole="admin">
              <Layout>
                <ErrorLogsPage />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
};

export default App;